(function(){
  'use strict';

  angular.module('irricrops')
    .controller("dialogTimetablePdfEquipoCtrl", ["$scope", "vinedo", "$mdDialog", "urls","$http","File",
        function($scope, vinedo, $mdDialog, urls, $http, File){
          $scope.vinedo = vinedo;
          $scope.fechaInicioDescarga = moment().toDate();
          $scope.fechaTerminoDescarga = moment().add(7, "days").toDate();

          $scope.changeDateInicio = function(){
            $scope.fechaTerminoDescarga = moment($scope.fechaInicioDescarga).add(6, "days").toDate();
          }

          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
          $scope.answer = function(answer) {
            $mdDialog.hide(answer);
          };
          $scope.descargarPdf = function(equipo){
            if(!equipo.loading){
              var fecha = moment($scope.fechaInicioDescarga).hours(0).minute(0).seconds(0).toDate();
              File.download(
                  urls.BASE+'/pdf/orden-riego',
                  {
                    equipo_id: equipo.id,
                    filename: equipo.nombre+"_"+moment($scope.fechaInicioDescarga).format('DD MMM YYYY')+".pdf",
                    fecha: fecha
                  },
                  function(){
                    equipo.loading = true;
                  },
                  function(){
                    //success
                    equipo.loading = false;
                  },
                  function(){
                    //error
                    equipo.loading = false;
                  }
                );
            }
          };

        }]);
})();
